import React from 'react';

const MessageTop = ({title, description}) => {
    return (
        <div className="col-12">
            <div className="card">
                <h5>{title}</h5>
                <p>{description}</p>
            </div>
        </div>
    );
}

export default MessageTop;